import React from "react";
import "./ImpactSection.css";
import img_1 from "../../assets/parij-borgohain-5bIWcv6ZtMY-unsplash.jpg";

const ImpactSection = () => {
  return (
    <div className="impact-container">
      {/* First Section with Image */}
      <div className="impact-section">
        <div className="impact-text">
          <h2>Hearing from the impacted works best</h2>
          <p>
            Filming impact stories from the perspective of those directly
            affected by the projects proves most effective. Personal narratives
            convey authenticity and emotional depth, resonating with audiences
            and donors alike, thereby amplifying the project's impact and
            fostering deeper connections with the community.
          </p>
        </div>
        <div className="impact-media">
          <img src={img_1} alt="Impact" />
        </div>
      </div>
    </div>
  );
};

export default ImpactSection;
